/**
 * Renders a complete inline <svg>…</svg> string from AI output inside
 * a Shadow DOM root so that any <style> block the model emitted is
 * scoped to this SVG only. Mobile's jovial_svg parses each SVG in
 * isolation; this gives the same isolation on web. CSS custom
 * properties (--neutral, --emphasis-*, --on-emphasis) inherit through
 * the shadow boundary from :root in global.css, so theme colors keep
 * working without any runtime substitution.
 *
 * Before paint we run layoutSvg() to resize each block to fit its
 * label and snap rows onto a uniform pitch — the AI types coordinates
 * blind, so this pass evens out gaps and arrow lengths.
 */
import React, { useEffect, useRef } from 'react';
import { layoutSvg } from '../../utils/svgLayout';

const InlineSvg = ({ svg }) => {
  const hostRef = useRef(null);

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;
    const root = host.shadowRoot || host.attachShadow({ mode: 'open' });
    const normalised = layoutSvg(svg);
    root.innerHTML = `<style>:host{display:block;max-height:500px;line-height:0;color:var(--text-primary);}svg{max-width:100%;height:auto;max-height:500px;}</style>${normalised}`;
  }, [svg]);

  return (
    <div
      ref={hostRef}
      className="inline-svg-wrapper not-prose"
      style={{ margin: '8px 0' }}
    />
  );
};

export default React.memo(InlineSvg);
